import TextInput from "../../../components/form-fields/TextInput";
import SecondaryLayout from "../../../components/authentication/layout/SecondaryLayout";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/basics/Button";
import { ButtonType } from "../../../helpers/shared/buttonStyling";
import RawHTML from "../../../components/basics/RawHTML";
import { fetchAuthSession } from "aws-amplify/auth";
import { useState, useEffect } from "react";
import { Region } from "../../../enums/shared/forms/Region";

interface IProps {
  onConfirm: () => void;
}

type UserDetail = {
  given_name: string;
  family_name: string;
  email: string;
  "custom:billing_code": string;
  "custom:agency_name": string;
  "custom:region": string;
};

type RegionList = "sg" | "hk" | "au";

const ConfirmAgentForm = ({ onConfirm }: IProps) => {
  const { t } = useTranslation("pages", { keyPrefix: "auth.login.confirmAgentForm" });
  const [attributes, setAttributes] = useState<UserDetail>();
  const [region, setRegion] = useState<RegionList>("sg");

  useEffect(() => {
    const setUserAttribute = async () => {
      try {
        const currentUser = await fetchAuthSession();
        const tempAttribute = currentUser?.tokens?.idToken?.payload || {};
        const tempRegion = Object.keys(tempAttribute).length > 0 && tempAttribute["custom:region"] ? tempAttribute["custom:region"] : "sg";
        setRegion(tempRegion as RegionList);
        setAttributes(tempAttribute as UserDetail);
      } catch (error) {
        console.error(error);
      }
    };
    setUserAttribute();
  }, []);

  return (
    <SecondaryLayout title={t("title")}>
      <form
        onSubmit={e => {
          e.preventDefault();
          onConfirm();
        }}
        className="space-y-8 mb-10"
      >
        <RawHTML boldedLinks={true} content={t(`form.${region}.content`)} />
        <div className="space-y-3 md:max-w-xs">
          <TextInput label={t("form.givenName")} value={attributes?.given_name} disabled />
          <TextInput label={t("form.familyName")} value={attributes?.family_name} disabled />
          <TextInput label={t("form.email")} value={attributes?.email} disabled />
          {region !== Region.AU && (
            <TextInput label={t(`form.${region}.billingCode`)} value={attributes ? attributes["custom:billing_code"] : ""} disabled />
          )}
          <TextInput label={t(`form.${region}.agencyName`)} value={attributes ? attributes["custom:agency_name"] : ""} disabled />
        </div>
        <Button type={ButtonType.PRIMARY}>{t("button.confirm")}</Button>
      </form>
    </SecondaryLayout>
  );
};

export default ConfirmAgentForm;
